import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";

import { apiEndPoints } from "../../../helpers/constants";
import { notify, notifyAPIMessages } from "../../../helpers/commonFunctions";
import { BASE_URL } from "../../../config";
import axios from "axios";
import { authHeaders } from "../../../helpers/axios";

export const reqToAddTenant = createAsyncThunk(
  "reqToAddTenant",
  async ({ data, onSuccess, onFailure }, thunkAPI) => {
    try {
      const response = await axios.post(
        BASE_URL + apiEndPoints.addTenant,
        data,
        authHeaders()
      );
      onSuccess(response?.data);
      return response;
    } catch (error) {
      notify(error?.response?.data?.message || "Network Error", "error");
      onFailure(error);
      return thunkAPI.rejectWithValue({
        message: error?.response?.data?.message || "Network Error",
        status: error?.response?.status,
      });
    }
  }
);

export const reqToGetTenantDetails = createAsyncThunk(
  "reqToGetTenantDetails",
  async ({ id, onSuccess, onFailure }, thunkAPI) => {
    try {
      const response = await axios.get(
        `${BASE_URL + apiEndPoints.getTenantDetails}/${id}`,
        authHeaders()
      );
      onSuccess(response);
      return response;
    } catch (error) {
      notify(error?.response?.data?.message || "Network Error", "error");
      onFailure(error);
      return thunkAPI.rejectWithValue({
        message: error?.response?.data?.message || "Network Error",
        status: error?.response?.status,
      });
    }
  }
);

export const reqToEditTenant = createAsyncThunk(
  "reqToEditTenant",
  async ({ id, data, onSuccess, onFailure }, thunkAPI) => {
    try {
      const response = await axios.post(
        `${BASE_URL}${apiEndPoints.editTenant}/${id}`,
        data,
        authHeaders()
      );
      onSuccess(response);
      return response;
    } catch (error) {
      notify(error?.response?.data?.message || "Network Error", "error");
      onFailure(error);
      return thunkAPI.rejectWithValue({
        message: error?.response?.data?.message || "Network Error",
        status: error?.response?.status,
      });
    }
  }
);

export const reqToEditStatusTenant = createAsyncThunk(
  "reqToEditStatusTenant",
  async ({ data, onSuccess, onFailure }, thunkAPI) => {
    try {
      const response = await axios.post(
        `${BASE_URL}${apiEndPoints.editStatusTenant}`,
        data,
        authHeaders()
      );
      onSuccess(response);
      return response;
    } catch (error) {
      notify(error?.response?.data?.message || "Network Error", "error");
      onFailure(error);
      return thunkAPI.rejectWithValue({
        message: error?.response?.data?.message || "Network Error",
        status: error?.response?.status,
      });
    }
  }
);

export const reqToResendInvite = createAsyncThunk(
  "reqToResendInvite",
  async ({ data, onSuccess, onFailure }, thunkAPI) => {
    try {
      const response = await axios.post(
        `${BASE_URL}${apiEndPoints.resendInvite}`,
        data,
        authHeaders()
      );
      onSuccess(response);
      return response;
    } catch (error) {
      notify(error?.response?.data?.message || "Network Error", "error");
      onFailure(error);
      return thunkAPI.rejectWithValue({
        message: error?.response?.data?.message || "Network Error",
        status: error?.response?.status,
      });
    }
  }
);

export const reqToGetTempToken = createAsyncThunk(
  "reqToGetTempToken",
  async ({ data, onSuccess, onFailure }, thunkAPI) => {
    try {
      const response = await axios.post(
        `${BASE_URL}${apiEndPoints.getTempToken}`,
        data,
        authHeaders()
      );
      onSuccess(response);
      return response;
    } catch (error) {
      notify(error?.response?.data?.message || "Network Error", "error");
      onFailure(error);
      return thunkAPI.rejectWithValue({
        message: error?.response?.data?.message || "Network Error",
        status: error?.response?.status,
      });
    }
  }
);

export const reqToAccessAccount = createAsyncThunk(
  "reqToAccessAccount",
  async ({ data, onSuccess, onFailure }, thunkAPI) => {
    try {
      const response = await axios.post(
        `${BASE_URL}${apiEndPoints.accessAccount}`,
        data,
        authHeaders()
      );
      onSuccess(response);
      return response;
    } catch (err) {
      notify(err?.response?.data?.message || "Network Error", "error");
      onFailure(err);
      return thunkAPI.rejectWithValue({
        message: err?.response?.data?.message || "Network Error",
        status: err?.response?.status,
      });
    }
  }
);

export const reqToGetTenantList = createAsyncThunk(
  "reqToGetTenantList",
  async ({ data, onSuccess, onFailure }, thunkAPI) => {
    try {
      const response = await axios.get(
        `${BASE_URL}${apiEndPoints.getTenants}?tab=${data?.tab || ""}&search=${
          data?.search || ""
        }&page=${data?.page || 1}&limit=${data?.limit || 10}`,
        authHeaders()
      );
      onSuccess(response?.data);
      return response;
    } catch (error) {
      notify(error?.response?.data?.message || "Network Error", "error");
      onFailure(error);
      return thunkAPI.rejectWithValue({
        message: error?.response?.data?.message || "Network Error",
        status: error?.response?.status,
      });
    }
  }
);

export const reqToGetCountries = createAsyncThunk(
  "reqToGetCountries",
  async ({ search = "", onSuccess, onFailure }, thunkAPI) => {
    try {
      const url = `${BASE_URL + apiEndPoints.countries}?search=${search}`;
      const response = await axios.get(url, authHeaders());
      onSuccess?.(response);
      return response.data;
    } catch (error) {
      notify(error?.response?.data?.message || "Network Error", "error");
      onFailure?.(error);
      return thunkAPI.rejectWithValue({
        message: error?.response?.data?.message || "Network Error",
        status: error?.response?.status,
      });
    }
  }
);

export const reqToGetCommunicationList = createAsyncThunk(
  "reqToGetCommunicationList",
  async ({ id, onSuccess, onFailure }, thunkAPI) => {
    try {
      const response = await axios.get(
        `${BASE_URL + apiEndPoints.getCommunicationlist}/${id}`,
        authHeaders()
      );
      onSuccess(response);
      return response;
    } catch (error) {
      notify(error?.response?.data?.message || "Network Error", "error");
      onFailure(error);
      return thunkAPI.rejectWithValue({
        message: error?.response?.data?.message || "Network Error",
        status: error?.response?.status,
      });
    }
  }
);

const tenantSlice = createSlice({
  name: "tenants",
  initialState: {
    loader: false,
    error: null,
    tenants: [],
    tenantDeatils: {},
    totalCount: 0,
    countries: [],
    communicationList: [],
    countriesLoader: false,
  },
  reducers: {
    reqToUpdateTenantStatus: (state, action) => {
      const tenant_id = action?.payload?.data?.tenant_id;
      const updatedStatus = action?.payload?.data?.action;
      // Find the tenant in the tenants array and update its status
      state.tenants = state.tenants.map((item) => {
        if (item.tenant && item.tenant.id === tenant_id) {
          return {
            ...item,
            tenant: {
              ...item.tenant,
              status: updatedStatus,
            },
          };
        }
        return item;
      });
    },
    updateTenantAccessStatus: (state, action) => {
      const tenant_id = action?.payload?.tenant_id;
      const updatedAccessStatus = action?.payload?.access_status;

      state.tenants = state.tenants.map((item) => {
        if (item.tenant && item.tenant.id === tenant_id) {
          return {
            ...item,
            tenant: {
              ...item.tenant,
              access_status: updatedAccessStatus,
            },
          };
        }
        return item;
      });
    },
  },
  extraReducers: (builder) => {
    // ADD TENANT
    builder.addCase(reqToAddTenant.pending, (state) => {
      state.loader = true;
    });
    builder.addCase(reqToAddTenant.fulfilled, (state, action) => {
      state.loader = false;
    });
    builder.addCase(reqToAddTenant.rejected, (state, action) => {
      state.loader = false;
      state.error = action.payload;
      notifyAPIMessages(action.payload?.message || "Something went wrong");
    });

    // GET ROLE DETAILS
    builder.addCase(reqToGetTenantDetails.pending, (state) => {
      state.loader = true;
    });
    builder.addCase(reqToGetTenantDetails.fulfilled, (state, action) => {
      state.loader = false;
      state.tenantDeatils = action.payload?.data?.data || [];
    });
    builder.addCase(reqToGetTenantDetails.rejected, (state, action) => {
      state.loader = false;
      state.error = action.payload;
      notifyAPIMessages(action.payload?.message || "Something went wrong");
    });

    // EDIT TENANT
    builder.addCase(reqToEditTenant.pending, (state) => {
      state.loader = true;
    });
    builder.addCase(reqToEditTenant.fulfilled, (state, action) => {
      state.loader = false;
    });
    builder.addCase(reqToEditTenant.rejected, (state, action) => {
      state.loader = false;
      state.error = action.payload;
    });

    // EDIT STATUS TENANT
    builder.addCase(reqToEditStatusTenant.pending, (state) => {
      state.loader = true;
    });
    builder.addCase(reqToEditStatusTenant.fulfilled, (state, action) => {
      state.loader = false;
    });
    builder.addCase(reqToEditStatusTenant.rejected, (state, action) => {
      state.loader = false;
      state.error = action.payload;
    });

    // RESEND INVITE
    builder.addCase(reqToResendInvite.pending, (state) => {
      state.loader = true;
    });
    builder.addCase(reqToResendInvite.fulfilled, (state, action) => {
      state.loader = false;
    });
    builder.addCase(reqToResendInvite.rejected, (state, action) => {
      state.loader = false;
      state.error = action.payload;
    });

    // GET TEMPTOKEN
    builder.addCase(reqToGetTempToken.pending, (state) => {
      state.loader = true;
    });
    builder.addCase(reqToGetTempToken.fulfilled, (state, action) => {
      state.loader = false;
    });
    builder.addCase(reqToGetTempToken.rejected, (state, action) => {
      state.loader = false;
      state.error = action.payload;
    });

    // REQUEST ACCESS
    builder.addCase(reqToAccessAccount.pending, (state) => {
      state.loader = true;
    });
    builder.addCase(reqToAccessAccount.fulfilled, (state, action) => {
      state.loader = false;
    });
    builder.addCase(reqToAccessAccount.rejected, (state, action) => {
      state.loader = false;
      state.error = action.payload;
    });

    // GET EMPLOYEES
    builder.addCase(reqToGetTenantList.pending, (state) => {
      state.loader = true;
    });
    builder.addCase(reqToGetTenantList.fulfilled, (state, action) => {
      state.loader = false;
      state.tenants = action.payload?.data?.data || [];
      state.totalCount = action.payload.headers["x-total-count"];
    });
    builder.addCase(reqToGetTenantList.rejected, (state, action) => {
      state.loader = false;
      state.error = action.payload;
      notifyAPIMessages(action.payload?.message || "Something went wrong");
    });

    // GET COUNTRIES
    builder.addCase(reqToGetCountries.pending, (state) => {
      state.countriesLoader = true;
    });
    builder.addCase(reqToGetCountries.fulfilled, (state, action) => {
      state.countriesLoader = false;
      state.countries = action.payload || [];
    });
    builder.addCase(reqToGetCountries.rejected, (state, action) => {
      state.countriesLoader = false;
      state.error = action.payload;
      notifyAPIMessages(action.payload?.message || "Something went wrong");
    });

    // GET ROLE DETAILS
    builder.addCase(reqToGetCommunicationList.pending, (state) => {
      state.loader = true;
    });
    builder.addCase(reqToGetCommunicationList.fulfilled, (state, action) => {
      state.loader = false;
      state.communicationList = action.payload?.data || [];
    });
    builder.addCase(reqToGetCommunicationList.rejected, (state, action) => {
      state.loader = false;
      state.error = action.payload;
      notifyAPIMessages(action.payload?.message || "Something went wrong");
    });
  },
});

export const { reqToUpdateTenantStatus, updateTenantAccessStatus } =
  tenantSlice.actions;

export default tenantSlice.reducer;
